var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5301 2.37335C10.5301 4.22177 12.0285 5.7202 13.8769 5.7202M3.53311 9.37025L11.3668 1.53662C11.6076 1.29585 11.728 1.17547 11.8435 1.08919C12.5533 0.559127 13.5272 0.559137 14.237 1.08922C14.3525 1.1755 14.4729 1.29588 14.7136 1.53665C14.9544 1.77742 15.0748 1.8978 15.161 2.01333C15.6911 2.7231 15.6911 3.69699 15.161 4.40676C15.0747 4.52228 14.9544 4.64267 14.7136 4.88343L6.87994 12.7171C6.37065 13.2264 6.11599 13.481 5.82586 13.6834C5.56834 13.863 5.29057 14.0116 4.99829 14.1263C4.669 14.2555 4.31586 14.3261 3.6096 14.4673L1.32617 14.924L1.78285 12.6406C1.92411 11.9343 1.99474 11.5812 2.1239 11.2519C2.23854 10.9596 2.3872 10.6818 2.56681 10.4243C2.76915 10.1342 3.02381 9.87954 3.53311 9.37025Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.1ba3aaac42ff61a15c475695a686effa.svg";
export { ForwardRef as ReactComponent };